import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const sendGaClickEvent = () => {
    window.dataLayer.push({
        event: 'click',
        'event_category': 'Header Scoreboard Click',
        'event_label': 'next'
    });
};

const NextArrow = ({ isAccountApp }) => (
    <Fragment>
        <div onClick={sendGaClickEvent} className="indicator">
            <FontAwesomeIcon icon={['fas', 'chevron-right']}/>
        </div>
        {isAccountApp ?
            <a href="/games" title="View more Games" alt="View more Games" onClick={e => e.stopPropagation()}>
                <div className="indicator">
                    <FontAwesomeIcon icon={['fas', 'calendar-alt']}/>
                </div>
            </a> :
            <Link to="/games" title="View more Games" alt="View more Games" onClick={e => e.stopPropagation()}>
                <div className="indicator">
                    <FontAwesomeIcon icon={['fas', 'calendar-alt']}/>
                </div>
            </Link>
        }
    </Fragment>
);

export default NextArrow;
